import { render } from "./LabelRegular.vue?vue&type=template&id=bf80fcfc&scoped=true"
import script from "./LabelRegular.vue?vue&type=script&lang=js"
export * from "./LabelRegular.vue?vue&type=script&lang=js"

import "./LabelRegular.vue?vue&type=style&index=0&id=bf80fcfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf80fcfc"]])

export default __exports__